module.exports = __webpack_public_path__ + "static/media/s-piper-camera-background.21d9cdf8.svg";